module.exports = __webpack_public_path__ + "static/media/angela_yang.dee7e616.png";